var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 60,
    viewBox: "0 0 69 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9207 5.53662H16.7937C14.6636 5.53662 12.6207 6.38282 11.1144 7.88907C9.60816 9.39531 8.76196 11.4382 8.76196 13.5684V45.6954C8.76196 47.8255 9.60816 49.8685 11.1144 51.3747C12.6207 52.8809 14.6636 53.7271 16.7937 53.7271H48.9207C51.0509 53.7271 53.0938 52.8809 54.6 51.3747C56.1063 49.8685 56.9525 47.8255 56.9525 45.6954V13.5684C56.9525 11.4382 56.1063 9.39531 54.6 7.88907C53.0938 6.38282 51.0509 5.53662 48.9207 5.53662ZM22.1482 16.2456C22.9425 16.2456 23.7189 16.4812 24.3793 16.9224C25.0397 17.3637 25.5545 17.9909 25.8584 18.7247C26.1624 19.4585 26.2419 20.266 26.0869 21.045C25.932 21.824 25.5495 22.5395 24.9879 23.1012C24.4262 23.6628 23.7107 24.0453 22.9317 24.2002C22.1527 24.3552 21.3452 24.2756 20.6114 23.9717C19.8776 23.6677 19.2504 23.153 18.8091 22.4926C18.3679 21.8322 18.1323 21.0558 18.1323 20.2615C18.1323 19.1964 18.5554 18.175 19.3086 17.4218C20.0617 16.6687 21.0831 16.2456 22.1482 16.2456ZM51.598 45.2403C51.6571 46.0104 51.4085 46.7726 50.9067 47.3597C50.4048 47.9469 49.6907 48.3111 48.9207 48.3726H16.7937L37.0605 30.1138C37.4008 29.8034 37.8448 29.6313 38.3054 29.6313C38.766 29.6313 39.21 29.8034 39.5504 30.1138L51.598 42.1079V45.2403Z",
    fill: "#D4E1FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.bcf137be.svg";
export { ForwardRef as ReactComponent };